import * as random from './random';
import { parseXml, xml2json } from './xmljson';
import validations from './validation/validations';
import { checkIfBrowserIsIE, isElementInViewport, checkIfBrowserIsFirefox } from './browserResolver';
import { getObjectFromSearch } from './urlUtils';

const REGEXP_NUMBERS = /^\d+$/;

const toProjectImgSrc = (src) => {
  const processedSrc = src.replace(/^\.\//, '');

  const baseUrl = window.baseUrl || 'http://cfe.firchuk.nixsolutions.com/';

  return `${baseUrl}${processedSrc}`;
};

const logoBase64 =
  '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';

const theValueIsANumber = (value) => REGEXP_NUMBERS.test(value);

const isNumber = (num) => {
  return !Number.isNaN(parseFloat(num)) && Number.isFinite(num);
};

const getDisplayComponentName = (OriginComponent) => {
  return OriginComponent.displayName || OriginComponent.name || 'Component';
};

const isBrowserFirefox = checkIfBrowserIsFirefox();

export {
  random,
  parseXml,
  xml2json,
  toProjectImgSrc,
  validations,
  logoBase64,
  theValueIsANumber,
  REGEXP_NUMBERS,
  isNumber,
  checkIfBrowserIsIE,
  isBrowserFirefox,
  getDisplayComponentName,
  getObjectFromSearch,
  isElementInViewport,
};
export * from './dates/dateFormatters';
export * from './interactErrorDictionary';
export {
  emailExpression,
  hostnameExpression,
  hoursMinutesSecondExpression,
  replaceSpecialSymbols,
} from './string/regExp';
export * from './file';
export * from './image';
export * from './downloadFileFromURL';
export * from './fontSize';
export { useDeepCompareMemoize } from './useDeepCompareMemoize';

export {
  b64DecodeUnicode,
  b64EncodeUnicode,
  parseHex,
  capitalizeString,
  compareStrings,
  optionalTextTrimmer,
  removeAllTagsFromString,
  sanitizeHtmlString,
} from './string';
export { getArrayOfUniqueItems, isIterable, sortArrayByDate, sortArrayByName } from './arrays';
export { getObjectKeysLength } from './getObjectKeysLength';
export { isEmpty } from './isEmpty';
export { getPositionElement } from './getPositionElement';
export { isFeatureEnabled } from './isFeatureEnabled';

export const authServerErrorPrefix = 'common:';
